export function isStripDisabled(strip) {
  return !!strip?.disabled
}

